import styled from 'styled-components'

export const StyledNewsSearchAlertEditor = styled.div``
